import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex items-center justify-center w-11 h-11 rounded-md bg-primary-500 text-background-50 shadow-lg transition-all duration-300 cursor-pointer ${
        show ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 translate-y-3"
      }`}
    >
      <i className="ri-arrow-up-line text-xl w-5 h-5 flex items-center justify-center" aria-hidden="true"></i>
    </a>
  );
}